import { DialogClose } from "@radix-ui/react-dialog";
import { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./dialog";

interface SlotSelectDialogProps {
  children: ReactNode;
  onClick: () => void;
}

const SlotSelectDialog = ({ children, onClick }: SlotSelectDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="bg-white">
        <DialogHeader>
          <DialogTitle>Book this slot?</DialogTitle>
        </DialogHeader>
        <div className="flex justify-between space-y-1">
          <DialogClose>
            <button className="inline-flex h-9 items-center justify-center whitespace-nowrap rounded-md bg-red-500/70 px-4 py-2 text-sm font-medium transition-colors hover:bg-red-500/50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50">
              Cancel
            </button>
          </DialogClose>
          <DialogClose>
            <button
              className="inline-flex h-9 items-center justify-center whitespace-nowrap rounded-md bg-primary px-4 py-2 text-sm font-medium transition-colors hover:border hover:border-primary hover:bg-[#8B70D7]/60 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
              onClick={onClick}
            >
              Book Slot
            </button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SlotSelectDialog;
